import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Panel } from 'react-bootstrap/lib';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Avatar from '../../Avatar';
import s from '../ViewMessage.css';

const FromMessage = ({ profileId, picture, displayName, content, createdAt }) => {

  let date = createdAt != null ? moment(parseInt(createdAt)).format('MM/DD/YYYY') : '';

  return (
    <div>
      <div className={cx(s.spaceBottom20)}>
        <div className={s.messageBoxFlex}>
          <div className={cx(s.messageProfilePicSec)}>
            <div className={cx(s.profileAvatarSectionLeft, 'profileAvatarSectionLeftAr')}>
              <Avatar
                source={picture}
                height={48}
                width={48}
                title={displayName}
                className={s.profileAvatar}
                withLink
                linkClassName={cx(s.profileAvatarLink, 'profileAvatarLinkRTL')}
                profileId={profileId}
              />
            </div>
          </div>
          <div className={cx(s.width100, s.radiusColor, s.fromRadius, 'fromRadiusRTL')}>
            <Panel className={cx(s.panelBubble, s.panelDark, s.panelBubbleLeft, 'viewMessageBubble', s.panelLeftMessage, 'viewBubbleLeftRTL')}>
              <span className={cx(s.txtBreak)}>
                {
                  content && (content.trim()).split("\n").map(function (item, index) {
                    return (
                      <span key={index}>{item}<br /></span>
                    )
                  })
                }
              </span>
              <div className={cx(s.timeText, s.spaceTop11)}>
                <span className={cx(s.messageDateText)}>{date}</span>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    </div>

  );
}

FromMessage.propTypes = {
  profileId: PropTypes.number.isRequired,
  picture: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  content: PropTypes.string,
  createdAt: PropTypes.string.isRequired
};

FromMessage.defaultProps = {
  createdAt: null
};
export default withStyles(s)(FromMessage);